import { User } from "@/interfaces/user";
import Axios from "axios";

export class ErrorReportService {
    public static async createReport(errorMsg: unknown, me: User | null) {
        const uri = "/api/webhooks/errorlog";
        const response = await Axios.post(uri, { errorMsg, me });

        return response.data;
    }
}
